import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import { Field, Float, ID, InputType } from 'type-graphql'

@InputType()
export class CreateOrderBankTransferArgs extends ActionArgs {
  @Field(() => ID)
  orderId: string

  @Field(() => ID, { nullable: true })
  userId?: string

  @Field(() => Boolean, { nullable: true })
  fromCheckout?: boolean

  // Explicit amount charged regardless of order balance; omitted means the order's
  // outstanding balance is charged instead.
  @Field(() => Float, { nullable: true })
  amount?: number
}

export type CreateOrderBankTransferResult = {
  paymentIntentId: string
  paymentId: string
  block: string
  bankInfo: {
    bankName?: string
    routingNumber?: string
    accountNumber?: string
    swiftCode?: string | null
    amount: number
    currency: string
    reference?: string
  }
}

export interface ICreateOrderBankTransfer extends IAction<CreateOrderBankTransferResult, CreateOrderBankTransferArgs> {}
